import React from 'react';
import PropTypes from 'prop-types';
import I18n from '@fiverr-private/fiverr_context/src/I18n';

import './style.scss';

const Pro = ({proSubCategories}) => (
    <div className="pro-wrapper">
        <label className="pro-verified"><I18n k={'gig_page_perseus.seller_card.pro.verified_by'}/></label>
        <ul>
            {proSubCategories.map((subcategory, index) => (
                <li key={index}>
                    {subcategory.name}
                </li>
            ))}
        </ul>
    </div>
);

Pro.propTypes = {
    proSubCategories: PropTypes.array
};

export default Pro;
